import React from "react";
import {observer} from "mobx-react";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import {Button, Dialog} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Utility from "../../Utility";
import Settings from "../../settings.json";
import PlayStoreBadge from '../../assets/img/google-play-badge.png';
import AppStoreBadge from '../../assets/img/app-store-badge.png';
import {useStores} from "../../Hooks";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {isWindows} from "react-device-detect";

const FrontlineArDialog = observer(() => {
    const {modalStore, generalStore} = useStores();
    const deeplink = modalStore.modalData?.deepLink;

    function closeModal() {
        modalStore.isFrontlineArDialogOpen = false;
    }

    async function install(getLatestDirectly = false) {
        await Utility.downloadApp(getLatestDirectly);
        closeModal();
    }

    return (
        <Dialog
            open={modalStore.isFrontlineArDialogOpen}
            onClose={closeModal}
            className='dialog frontline-dialog'
            maxWidth='sm'
            fullWidth
        >
            <CloseIcon className='close-button' onClick={closeModal}/>
            <div className='frontline-ar-title'>
                {generalStore.translate('downloadApp')}
            </div>
            <Button
                variant='contained'
                className='install-button bg-classic-button-normal rounded-button'
                onClick={() => install(false)}
            >
                    <>{generalStore.translate('installNow')} <SaveAltIcon/></>
            </Button>
            <ConditionalComponent if={!Utility.isTablet() && !Utility.isMobile() && !generalStore.workspaceIsHP}>
                <div className='frontline-ar-title'>
                    {generalStore.translate("orInstallMobileApp.")}
                </div>
                <div className='store-badges-container'>
                    <img src={PlayStoreBadge} alt='play-store-badge' className='store-badge'
                         onClick={() => window.open(Settings.playStoreLink)}/>
                    <img src={AppStoreBadge} alt='play-store-badge' className='store-badge'
                         onClick={() => window.open(Settings.appStoreLink)}/>
                </div>
            </ConditionalComponent>
            <ConditionalComponent if={isWindows && !generalStore.workspaceIsHP}>
                <div className='frontline-ar-title small'>
                    {generalStore.translate('havingTroubleDownloadingFromTheStore')}?
                    &nbsp;<span className='click-to-deeplink' onClick={() => install(true)}>{generalStore.translate('download')} .msi</span>
                </div>
            </ConditionalComponent>
            <div className='frontline-ar-title'>
                {generalStore.translate('alreadyHaveTheApp')}
                &nbsp;<a className='click-to-deeplink' href={deeplink}>{generalStore.translate('clickHereToOpenIt')}</a>
            </div>
        </Dialog>
    )
        ;
})

export default FrontlineArDialog;
